import {endpoints} from './endpoints'
import request from '../../request'

export function addItemsAssociations(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.addItemsAssociations,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function removeItemsAssociations(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.removeItemsAssociations,
			method: 'delete',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}